import React from 'react';
import NoResultsFound from '../../NoResultsFound';
import type { INewsFilters } from '../../../interfaces/NewsFilter.interface';
import type { NewsAEMImages } from '../../../interfaces/NewsAEM.interface';
import { hasActiveFilters } from '../utils/filterUtils';

interface NewsEmptyStateProps {
  filters: INewsFilters;
  title: string;
  description: string;
  emptyDescription?: string;
  aemImages?: NewsAEMImages;
}

/**
 * Reusable empty state component for news sections
 */
const NewsEmptyState: React.FC<NewsEmptyStateProps> = ({
  filters,
  title,
  description,
  emptyDescription,
  aemImages,
}) => {
  const activeFilters = hasActiveFilters(filters);
  const finalDescription = activeFilters ? description : (emptyDescription ?? description);

  return (
    <NoResultsFound
      title={title}
      description={finalDescription}
      aemImages={aemImages}
    />
  );
};

export default NewsEmptyState;

